<template>
  <!-- 账号管理设置页面 -->
  <!-- 设置页面的内容区域 -->
  <div class="config_main_manage_page_wraper">
    <div class="config_main_manage_page_content">
      <!-- 设置页面  内容区域样式   以上部分都是公共样式 -->

      <!-- // 代号 20240124-1 -->
      <config-title-hang>
        <span slot="config_title_hang_ele2"> {{ oneHostData.gatewayTypeName }}({{ oneHostData.uniqueCode16 }})
        </span>
      </config-title-hang>
      <config-hang @click.native="configDeviceBtnhandle(oneHostData, 1, 'setGateway')">
        <span slot="config_hang_ele2_1"
          :style="{ color: (oneHostData.errorInfo && oneHostData.errorInfo !== '') ? 'red' : '' }">
          {{ oneHostData.errorInfo && oneHostData.errorInfo !== '' ? '[' + oneHostData.errorInfo + ']' +
            oneHostData.gatewayName :
            oneHostData.gatewayName
          }}
        </span>
        <span slot="config_hang_ele2_2">主机地址:{{ oneHostData.borderAddress }} IP:{{ oneHostData.intranetIp }}</span>
        <!-- <span slot="config_button_hang_ele5" @click.stop="seekDeviceBtnHandle(value.productId)">主机定位</span> -->
        <span slot="config_hang_ele3">设置</span>
        <img slot="config_hang_ele4" src="~assets/img/config/youjiantou.png" alt />
      </config-hang>

      <!-- //代号20220220-6 -->
      <config-title-hang>
        <span slot="config_title_hang_ele2">添加设备</span>
      </config-title-hang>
      <config-hang @click.native="configDeviceBtnhandle(null, 0, 'add')">
        <span slot="config_hang_ele2" class="device_go_online_btn_corol">添加一个新设备</span>
        <img slot="config_hang_ele4" src="~assets/img/config/youjiantou.png" alt />
      </config-hang>

      <!-- // 代号 20241212-1 -->
      <config-title-hang>
        <span slot="config_title_hang_ele2">在线设备({{ computedonLineListNumber }}台)</span>
        <img slot="config_title_hang_ele5_img" src="~assets/img/config/shuaxin_bai.png" @click="updataBtnHandle" alt />
        <span slot="config_title_hang_ele5" @click="updataBtnHandle">刷新</span>
      </config-title-hang>
      <!-- //代号20220319-1 -->
      <config-hang @click.native="configDeviceBtnhandle(value, index, 'onLine')"
        v-for="(value, index) in oneHostDeviceListData.onLineList" :key="value.productId">
        <span slot="config_button_hang_ele5" @click.stop="seekDeviceBtnHandle(value.productId)">设备定位</span>

        <span slot="config_hang_ele2_1" :style="{ color: (value.errorInfo && value.errorInfo !== '') ? 'red' : '' }">
          {{ value.errorInfo && value.errorInfo !== '' ? '[' + value.errorInfo + ']' + value.productName :
            value.productName
          }}
        </span>

        <span slot="config_hang_ele2_2"> 地址:{{ value.borderInnerAddress }} 代码:{{ formatProductProgram(value) }}</span>
        <span slot="config_hang_ele3"> {{ value.remark }}</span>

        <div v-if="(value.errorInfo && value.errorInfo != '') || (oneHostData.errorInfo && oneHostData.errorInfo != '')"
          slot="config_hang_da_view_img" @click.stop="deleteDeviceBtnHandle(oneHostDeviceListData.onLineList, index)">
          <img src="~assets/img/config/delete_lan.png" alt />
        </div>
        <img v-else slot="config_hang_ele4" src="~assets/img/config/youjiantou.png" alt />

      </config-hang>

      <config-title-hang v-show="oneHostDeviceListData.offLineList.length != 0">
        <span slot="config_title_hang_ele2">离线设备({{ computedoffLineListNumber }}台)</span>
      </config-title-hang>
      <!-- //代号20220319-1 -->
      <config-hang @click.native="configDeviceBtnhandle(value, index, 'offLine')"
        v-for="(value, index) in oneHostDeviceListData.offLineList" :key="value.productId">
        <span slot="config_button_hang_ele5" @click.stop="seekDeviceBtnHandle(value.productId)">设备定位</span>
        <span slot="config_hang_ele2_1" :style="{ color: (value.errorInfo && value.errorInfo !== '') ? 'red' : '' }">
          {{ value.errorInfo && value.errorInfo !== '' ? '[' + value.errorInfo + ']' + value.productName :
            value.productName
          }}
        </span>
        <span slot="config_hang_ele2_2" class="device_go_online_btn_corol"> 地址:{{ value.borderInnerAddress
          }} 代码:{{ formatProductProgram(value) }}</span>
        <span slot="config_hang_ele3">{{ value.remark }}</span>
        <!-- //代号20220319-1 -->
        <div slot="config_hang_da_view_img"
          @click.stop="deleteDeviceBtnHandle(oneHostDeviceListData.offLineList, index)">
          <img src="~assets/img/config/delete_lan.png" alt />
        </div>
      </config-hang>

    </div>
  </div>
</template>

<script>
import configHang from "components/common/config/config-hang";
import configTitleHang from "components/common/config/config-title-hang";
import { set } from "vuedraggable";
export default {
  data() {
    return {
      oneHostDeviceListData: {
        ////服务器请求到的主机下面的设备列表
        offLineList: [],
        onLineList: []
      },
      oneHostData: {
        ////一个主机的信息
      }
    };
  },
  components: {
    configHang,
    configTitleHang
  },
  methods: {
    formatProductProgram(value) {
      if (!value) {
        return "";
      }
      if (value.firmwareVersion === undefined || value.firmwareVersion === null || value.firmwareVersion === "") {
        return value.program || "";
      }
      return (value.program || "") + "|" + value.firmwareVersion;
    },
    updataBtnHandle() {
      ///刷新设备按钮被点击了
      // console.log(this.$route.query.typeId);

      ///获取网关下的产品列表 接口，获取数据
      this.$request({
        method: "post",
        url: "/product/findProductListByGatewayId",
        data: {
          token: this.$store.state.token,
          gatewayId: this.oneHostData.gatewayId,
          typeId: "", ///设备类型id （空的时候所有类型）
          state: 1 ///是否刷底层数据 0:不查 1:查
        }
      })
        .then(res => {
          if (res.data.code != 0) {
            this.$showTipsToast(3, res.data.message);
            ////说明信息填写错误,控制失败了，
            return;
          } else {
            ////、控制成功了
            console.log(res.data.data);
            // 排序 20200624
            this.oneHostDeviceListData = res.data.data; ////拿到服务器返回的数据结果

            this.$store.dispatch(
              "asyUpdataoneHostDeviceListData",
              this.oneHostDeviceListData
            ); ///异步提交信息到仓库

            // this.$store.dispatch("asyUpdataServeSceneData", this.ServeSceneData); ///异步提交信息到仓库
            // this.$showTipsToast(1, "获取成功", true); ////提示框
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    configDeviceBtnhandle(value, index, type) {
      // 网关错误判断
      if (!(this.oneHostData.errorInfo == null || this.oneHostData.errorInfo == "")) {
        if (type != "setGateway") {
          // 网关有错误信息时,允许进行网关管理
          this.$showTipsToast(3, "请先解决" + this.oneHostData.errorInfo);
          return;
        }

      }

      console.log(value)
      ///一个设备修改查看按钮被点击了
      if (type == "setGateway") {
        this.$router.push({
          path: "Gateway485Manage",
          query: {
            address: "",
            remark: "",
            productId: "",
            Cindex: "",
            productCode: "",
            program: "",
            type: type
          }
        });
      }
      else if (type == "add") {
        //获取当前用户网关下可用的推荐的产品内部地址(thread 网关)
        this.$request({
          method: "post",
          url: "/product/getUsableBorderInnerAddress",
          data: {
            token: this.$store.state.token,
            gatewayId: this.oneHostData.gatewayId,
          }
        })
          .then(res => {
            if (res.data.code != 0) {
              this.$showTipsToast(3, res.data.message);
              ////说明信息填写错误,控制失败了，
              return;
            } else {
              ////、控制成功了
              let data = res.data.data; ////拿到服务器返回的数据结果
              console.log("拿到可用的产品地址:", data.borderInnerAddress);

              //代号20220319-1
              this.$router.push({
                path: "addNewDevice",
                query: {
                  address: data.borderInnerAddress,
                  remark: "设备" + data.borderInnerAddress,
                  productId: "",
                  Cindex: "",
                  productCode: "",
                  program: "",
                  type: type
                }
              });

            }
          })
          .catch(error => {
            console.log(error);
          });
      }
      else if (type == "onLine") {
        this.$router.push({
          path: "device485Manage",
          query: {
            address: value.borderInnerAddress,
            borderAddress: value.borderAddress,
            borderInnerAddress: value.borderInnerAddress,
            threadIp: "",
            realAddress: value.address,
            remark: value.remark,
            productName: value.productName,
            productId: value.productId,
            Cindex: index,
            productCode: value.productCode,
            productSource: value.productSource,
            program: value.program,
            type: type
          }
        });
      }
      else if (type == "offLine") {
        this.$router.push({
          path: "device485Manage",
          query: {
            address: value.borderInnerAddress,
            borderAddress: value.borderAddress,
            borderInnerAddress: value.borderInnerAddress,
            threadIp: "",
            realAddress: value.address,
            remark: value.remark,
            productName: value.productName,
            productId: value.productId,
            Cindex: index,
            productCode: value.productCode,
            productSource: value.productSource,
            program: value.program,
            type: type
          }
        });
      }
    },
    deleteDeviceBtnHandle(value, index) {
      // 删除离线设备按钮被点击了  需要二次弹窗确认
      this.$showTipsToast(10, value, false, 1000, index);
    },
    seekDeviceBtnHandle(productId) {
      ///   寻找设备按钮被点击了
      /// 寻找产品位置接口，获取数据
      this.$request({
        method: "post",
        url: "/product/productLocation",
        data: {
          token: this.$store.state.token,
          productId: productId
        }
      })
        .then(res => {
          if (res.data.code != 0) {
            this.$showTipsToast(3, res.data.message);
            ////说明信息填写错误,控制失败了，
            return;
          } else {
            ////、控制成功了
            // this.serveDeviceDetailsData = res.data.data; ////拿到服务器返回的数据结果
            this.$showTipsToast(1, "定位成功~", true, 3000); ////提示框
          }
        })
        .catch(error => {
          console.log(error);
        });
    },


  },
  computed: {
    computedoffLineListNumber() {
      //离线设备个数
      return this.oneHostDeviceListData.offLineList.length;
    },
    computedonLineListNumber() {
      // 在线设备个数
      return this.oneHostDeviceListData.onLineList.length;
    }
  },
  mounted() {
    console.log("mounted阶段");
  },
  created() {
    console.log("created阶段");
    this.oneHostData = this.$store.state.configinfo.oneHostData; ///拿到仓库当前主机的信息
    this.oneHostDeviceListData = this.$store.state.configinfo.oneHostDeviceListData; ///拿到仓库当前主机下的设备列表
    console.log(this.oneHostDeviceListData);
    //  this.$forceUpdate()  ////强制更新视图
  }
};
</script>

<style>
.device_go_online_btn_corol {
  color: var(--primary-color);
}
</style>
